import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { actions } from "../redux/dashboardSaga";

// import { RevenueByAgency } from "./RevenueByAgency";
import { RevenueByMonth } from "./RevenueByMonth";
// import { TransactionAmount } from "./TransactionAmount";
import { TransactionCount } from "./TransactionCount";
import { ReceiptsPerMonth } from "./ReceiptsPerMonth";
// import { RefundedReceipts } from "./RefundedReceipts";
// import { CollectedReceipts } from "./CollectedReceipts";
import { DailyStatistics } from "./DailyStatistics";
import {dsReducerActions} from "..";
import {LoadingModal} from "../../UI/components/LoadingModal";

import { Row, Col } from "react-bootstrap";

export function AdminDashboard() {

  const dispatch = useDispatch();

    const { dashboard } = useSelector( state => state);

    const { dailyStatisticsLoading, monthlyTransactionsLoading, monthlyRevenueLoading,monthlyReceiptsLoading, dailyStatistics, monthlyTransactions, monthlyRevenue, monthlyReceipts } = dashboard;
    
    const dashboardDataLoading = (dailyStatisticsLoading || monthlyTransactionsLoading || monthlyRevenueLoading || monthlyReceiptsLoading); //show loading if any one of them is still loading

    console.log("dashboardDataLoading: " + dashboardDataLoading);

    useEffect(() => {
      
      //reset first on init load
      dispatch(dsReducerActions.resetDashboard());

      dispatch(actions.fetchDailyStats());
      dispatch(actions.fetchMonthlyReceipts());
      dispatch(actions.fetchMonthlyTrans());
      dispatch(actions.fetchMonthlyRevenue());
    }, [dispatch]);

  return (
    <>
      <Row>
        <Col lg={4} md={12} sm={12}>
          
          <DailyStatistics 
            className="card-stretch gutter-b" 
            dailyStats={dailyStatistics} 
          />
        </Col>
        <Col lg={8} md={12} sm={12}>
          <ReceiptsPerMonth 
            className="card-stretch gutter-b" 
            data={monthlyReceipts}
          />
        </Col>

      </Row>
      <Row>

        <Col lg={6} md={12} sm={12}>
          <TransactionCount 
            className="card-stretch gutter-b" 
            data={monthlyTransactions}
          />
        </Col>
        <Col lg={6} md={12} sm={12}>
          <RevenueByMonth 
            className="card-stretch gutter-b" 
            data={monthlyRevenue}
          />
        </Col>
        {/* <div className="col-lg-4 col-xxl-4">
          <RefundedReceipts className="card-stretch gutter-b" />
        </div> */}
      </Row>
      {/* <div className="row">
        <div className="col-lg-4 col-xxl-4">
          <RevenueByAgency className="card-stretch gutter-b" />
        </div>
        <div className="col-lg-4 col-xxl-4">
          <RevenueByMonth className="card-stretch gutter-b" />
        </div>
        <div className="col-lg-4 col-xxl-4">
          <TransactionAmount className="card-stretch gutter-b" />
        </div>
      </div> */}

      <LoadingModal isLoading = {dashboardDataLoading} text = "Loading..." />

    </>
  );
}
